import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div class="control-group">
  <label class="control-label">{{i18n
      "groups.manage.membership.access"
    }}</label>

  <label>
    <Input
      @type="checkbox"
      class="group-form-public-admission"
      @checked={{this.model.public_admission}}
      disabled={{this.disablePublicSetting}}
    />

    {{i18n "groups.public_admission"}}
  </label>

  <label>
    <Input
      @type="checkbox"
      class="group-form-public-exit"
      @checked={{this.model.public_exit}}
    />

    {{i18n "groups.public_exit"}}
  </label>

  <label>
    <Input
      @type="checkbox"
      class="group-form-allow-membership-requests"
      @checked={{this.model.allow_membership_requests}}
      disabled={{this.disableMembershipRequestSetting}}
    />

    {{i18n "groups.allow_membership_requests"}}
  </label>

  {{#if this.model.allow_membership_requests}}
    <div>
      <label for="membership-request-template">
        {{i18n "groups.membership_request_template"}}
      </label>

      <ExpandingTextArea
        {{on
          "input"
          (with-event-value (fn (mut this.model.membership_request_template)))
        }}
        value={{this.model.membership_request_template}}
        name="membership-request-template"
        class="group-form-membership-request-template input-xxlarge"
      />
    </div>
  {{/if}}
</div>

{{#if this.model.can_admin_group}}
  <div class="control-group">
    <label class="control-label">{{i18n
        "admin.groups.manage.membership.automatic"
      }}</label>

    <label for="automatic_membership">
      {{i18n
        "admin.groups.manage.membership.automatic_membership_email_domains"
      }}
    </label>

    <ListSetting
      @name="automatic_membership"
      @value={{this.emailDomains}}
      @choices={{this.emailDomains}}
      @settingName="name"
      @nameProperty={{null}}
      @valueProperty={{null}}
      @onChange={{action "onChangeEmailDomainsSetting"}}
      @options={{hash allowAny=true}}
      class="group-form-automatic-membership-automatic"
    />

    {{#if this.showAssociatedGroups}}
      <label for="automatic_membership_associated_groups">
        {{i18n
          "admin.groups.manage.membership.automatic_membership_associated_groups"
        }}
      </label>

      <ListSetting
        @name="automatic_membership_associated_groups"
        @value={{this.model.associatedGroupIds}}
        @choices={{this.associatedGroups}}
        @settingName="name"
        @nameProperty="label"
        @valueProperty="id"
        @onChange={{fn (mut this.model.associated_group_ids)}}
        class="group-form-automatic-membership-associated-groups"
      />
    {{/if}}
  </div>

  <span>
    <PluginOutlet
      @name="groups-form-membership-below-automatic"
      @connectorTagName="div"
      @outletArgs={{hash model=this.model}}
    />
  </span>

  <div class="control-group">
    <label class="control-label">{{i18n
        "admin.groups.manage.membership.effects"
      }}</label>
    <label for="grant_trust_level">{{i18n
        "admin.groups.manage.membership.trust_levels_title"
      }}</label>

    <ComboBox
      @name="grant_trust_level"
      @valueProperty="value"
      @value={{this.groupTrustLevel}}
      @content={{this.trustLevelOptions}}
      @onChange={{fn (mut this.model.grant_trust_level)}}
      class="groups-form-grant-trust-level"
    />
    <label>
      <Input
        @type="checkbox"
        @checked={{this.model.primary_group}}
        class="groups-form-primary-group"
      />

      {{i18n "admin.groups.manage.membership.primary_group"}}
    </label>
  </div>

  <div class="control-group">
    <label class="control-label" for="title">
      {{i18n "admin.groups.default_title"}}
    </label>

    <Input @value={{this.model.title}} name="title" class="input-xxlarge" />

    <div class="control-instructions">
      {{i18n "admin.groups.default_title_description"}}
    </div>
  </div>
{{/if}}

{{#if this.canEdit}}
  <div class="control-group">
    <GroupFlairInputs @model={{this.model}} />
  </div>
{{/if}}
*/
{
  "id": "vUgBNiHJ",
  "block": "[[[10,0],[14,0,\"control-group\"],[12],[1,\"\\n  \"],[10,\"label\"],[14,0,\"control-label\"],[12],[1,[28,[35,0],[\"groups.manage.membership.access\"],null]],[13],[1,\"\\n\\n  \"],[10,\"label\"],[12],[1,\"\\n    \"],[8,[39,1],[[24,0,\"group-form-public-admission\"],[16,\"disabled\",[30,0,[\"disablePublicSetting\"]]]],[[\"@type\",\"@checked\"],[\"checkbox\",[30,0,[\"model\",\"public_admission\"]]]],null],[1,\"\\n\\n    \"],[1,[28,[35,0],[\"groups.public_admission\"],null]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,\"label\"],[12],[1,\"\\n    \"],[8,[39,1],[[24,0,\"group-form-public-exit\"]],[[\"@type\",\"@checked\"],[\"checkbox\",[30,0,[\"model\",\"public_exit\"]]]],null],[1,\"\\n\\n    \"],[1,[28,[35,0],[\"groups.public_exit\"],null]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,\"label\"],[12],[1,\"\\n    \"],[8,[39,1],[[24,0,\"group-form-allow-membership-requests\"],[16,\"disabled\",[30,0,[\"disableMembershipRequestSetting\"]]]],[[\"@type\",\"@checked\"],[\"checkbox\",[30,0,[\"model\",\"allow_membership_requests\"]]]],null],[1,\"\\n\\n    \"],[1,[28,[35,0],[\"groups.allow_membership_requests\"],null]],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"model\",\"allow_membership_requests\"]],[[[1,\"    \"],[10,0],[12],[1,\"\\n      \"],[10,\"label\"],[14,\"for\",\"membership-request-template\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"groups.membership_request_template\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[8,[39,3],[[16,2,[30,0,[\"model\",\"membership_request_template\"]]],[24,3,\"membership-request-template\"],[24,0,\"group-form-membership-request-template input-xxlarge\"],[4,[38,4],[\"input\",[28,[37,5],[[28,[37,6],[[28,[37,7],[[30,0,[\"model\",\"membership_request_template\"]]],null]],null]],null]],null]],null,null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\\n\"],[41,[30,0,[\"model\",\"can_admin_group\"]],[[[1,\"  \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n    \"],[10,\"label\"],[14,0,\"control-label\"],[12],[1,[28,[35,0],[\"admin.groups.manage.membership.automatic\"],null]],[13],[1,\"\\n\\n    \"],[10,\"label\"],[14,\"for\",\"automatic_membership\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"admin.groups.manage.membership.automatic_membership_email_domains\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[8,[39,8],[[24,0,\"group-form-automatic-membership-automatic\"]],[[\"@name\",\"@value\",\"@choices\",\"@settingName\",\"@nameProperty\",\"@valueProperty\",\"@onChange\",\"@options\"],[\"automatic_membership\",[30,0,[\"emailDomains\"]],[30,0,[\"emailDomains\"]],\"name\",null,null,[28,[37,9],[[30,0],\"onChangeEmailDomainsSetting\"],null],[28,[37,10],null,[[\"allowAny\"],[true]]]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"showAssociatedGroups\"]],[[[1,\"      \"],[10,\"label\"],[14,\"for\",\"automatic_membership_associated_groups\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"admin.groups.manage.membership.automatic_membership_associated_groups\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[8,[39,8],[[24,0,\"group-form-automatic-membership-associated-groups\"]],[[\"@name\",\"@value\",\"@choices\",\"@settingName\",\"@nameProperty\",\"@valueProperty\",\"@onChange\"],[\"automatic_membership_associated_groups\",[30,0,[\"model\",\"associatedGroupIds\"]],[30,0,[\"associatedGroups\"]],\"name\",\"label\",\"id\",[28,[37,6],[[28,[37,7],[[30,0,[\"model\",\"associated_group_ids\"]]],null]],null]]],null],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\\n  \"],[10,1],[12],[1,\"\\n    \"],[8,[39,11],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"groups-form-membership-below-automatic\",\"div\",[28,[37,10],null,[[\"model\"],[[30,0,[\"model\"]]]]]]],null],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n    \"],[10,\"label\"],[14,0,\"control-label\"],[12],[1,[28,[35,0],[\"admin.groups.manage.membership.effects\"],null]],[13],[1,\"\\n    \"],[10,\"label\"],[14,\"for\",\"grant_trust_level\"],[12],[1,[28,[35,0],[\"admin.groups.manage.membership.trust_levels_title\"],null]],[13],[1,\"\\n\\n    \"],[8,[39,12],[[24,0,\"groups-form-grant-trust-level\"]],[[\"@name\",\"@valueProperty\",\"@value\",\"@content\",\"@onChange\"],[\"grant_trust_level\",\"value\",[30,0,[\"groupTrustLevel\"]],[30,0,[\"trustLevelOptions\"]],[28,[37,6],[[28,[37,7],[[30,0,[\"model\",\"grant_trust_level\"]]],null]],null]]],null],[1,\"\\n    \"],[10,\"label\"],[12],[1,\"\\n      \"],[8,[39,1],[[24,0,\"groups-form-primary-group\"]],[[\"@type\",\"@checked\"],[\"checkbox\",[30,0,[\"model\",\"primary_group\"]]]],null],[1,\"\\n\\n      \"],[1,[28,[35,0],[\"admin.groups.manage.membership.primary_group\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n    \"],[10,\"label\"],[14,0,\"control-label\"],[14,\"for\",\"title\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"admin.groups.default_title\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[8,[39,1],[[24,3,\"title\"],[24,0,\"input-xxlarge\"]],[[\"@value\"],[[30,0,[\"model\",\"title\"]]]],null],[1,\"\\n\\n    \"],[10,0],[14,0,\"control-instructions\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"admin.groups.default_title_description\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"canEdit\"]],[[[1,\"  \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n    \"],[8,[39,13],null,[[\"@model\"],[[30,0,[\"model\"]]]],null],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[],false,[\"i18n\",\"input\",\"if\",\"expanding-text-area\",\"on\",\"with-event-value\",\"fn\",\"mut\",\"list-setting\",\"action\",\"hash\",\"plugin-outlet\",\"combo-box\",\"group-flair-inputs\"]]",
  "moduleName": "discourse/components/groups-form-membership-fields.hbs",
  "isStrictMode": false
});